<template>
  <div
    v-if="!searchOpen"
    class="flex items-start border-b-1 border-gray-light px-[var(--page-gutter)] py-4 lg:p-2.5 lg:pr-[15px]"
  >
    <div class="flex min-w-0 flex-1 gap-3 lg:gap-3.5">
      <p
        class="bg-gray-dark flex h-11 w-11 items-center justify-center rounded-full text-center text-white font-helvetica-700 text-[24px] lg:h-[50px] lg:w-[50px] lg:text-[32px]"
      >
        {{ managerInitial }}
      </p>
      <div class="min-w-0">
        <p class="font-helvetica-700 font-bold text-[16px] text-gray-dark lg:text-[18px]">
          Ассистент поддержки
        </p>
        <p class="font-helvetica-400 font-normal text-[14px] text-gray-dark lg:text-[18px]">
          {{ managerName }}
        </p>
        <p
          v-if="managerName"
          class="font-helvetica-400 font-normal text-[12px] lg:text-[14px]"
          :class="managerOnline ? 'text-green-button' : 'text-extra-text-color'"
        >
          {{ managerOnline ? "В сети" : "Не в сети" }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="ml-auto self-center shrink-0 cursor-pointer text-gray-light hover:text-gray-dark"
      aria-label="Открыть поиск"
      @click="emit('openSearch')"
    >
      <SvgoIconComponentChatIconLupa></SvgoIconComponentChatIconLupa>
    </button>
  </div>

  <div
    v-else
    class="relative border-b-1 border-gray-light px-[var(--page-gutter)] py-3 lg:px-[15px] lg:py-[12px]"
  >
    <div class="flex items-center gap-3 lg:gap-[12px]">
      <button
        type="button"
        class="shrink-0 self-center cursor-pointer text-gray-light hover:text-gray-dark"
        aria-label="Закрыть поиск"
        @click="handleCloseSearch"
      >
        <SvgoIconComponentChatIconArrowBackToChat class="shrink-0 text-gray-light"></SvgoIconComponentChatIconArrowBackToChat>
      </button>

      <div
        class="flex min-w-0 flex-1 items-center gap-3 rounded-[12px] bg-white-gray px-3.5 py-3 lg:gap-4 lg:px-[14px] lg:py-[11px]"
      >
        <SvgoIconComponentChatIconLupa class="shrink-0 text-gray-light"></SvgoIconComponentChatIconLupa>

        <input
          ref="searchInputRef"
          v-model="searchValue"
          type="text"
          maxlength="500"
          class="w-full bg-transparent p-0 font-helvetica-400 text-[16px] leading-[22px] text-gray-dark placeholder:text-gray-light outline-none lg:text-[18px] lg:leading-[24px]"
          placeholder="Поиск по чату"
          @keydown.enter.prevent="emit('search')"
        />

        <button
          type="button"
          class="shrink-0 cursor-pointer text-gray-light hover:text-gray-dark"
          aria-label="Фильтр по дате"
          @click="showDatePopover = !showDatePopover"
        >
          <SvgoIconComponentRIconCalendar></SvgoIconComponentRIconCalendar>
        </button>
      </div>
    </div>

    <div
      v-if="showDatePopover"
      class="fixed inset-0 z-[1500] bg-black/30 lg:hidden"
      @click.self="showDatePopover = false"
    >
      <section
        class="absolute inset-x-0 bottom-0 rounded-t-[28px] bg-white px-5 pb-[calc(var(--layout-mobile-nav-height)+24px)] pt-5 shadow-[0_-12px_32px_rgb(0_0_0_/_0.12)]"
      >
        <div class="mx-auto flex w-full max-w-[var(--layout-mobile-max-width)] flex-col gap-4">
          <div class="relative flex items-center justify-center">
            <p class="text-[24px] font-helvetica-700 text-gray-dark">Период</p>
            <button
              type="button"
              class="absolute right-0 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-gray-border bg-white-gray text-gray-dark"
              aria-label="Закрыть фильтр по дате"
              @click="showDatePopover = false"
            >
              <span class="absolute h-[1.5px] w-4 rotate-45 rounded-full bg-current"></span>
              <span class="absolute h-[1.5px] w-4 -rotate-45 rounded-full bg-current"></span>
            </button>
          </div>

          <div class="rounded-[20px] border border-gray-border bg-white px-4 py-4 shadow-sm">
            <div class="grid grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)] items-center gap-3 px-1">
              <div class="flex flex-col gap-1">
                <span class="text-[16px] font-helvetica-400 text-gray-dark">с</span>
                <div class="flex min-w-0 items-center gap-1.5 rounded-[12px] border border-gray-border bg-white px-[10px] py-[12px]">
                  <SvgoIconComponentRIconCalendar class="text-orange"></SvgoIconComponentRIconCalendar>
                  <input
                    :value="searchDateFrom"
                    type="date"
                    class="min-w-0 w-full bg-transparent p-0 font-helvetica-400 text-[14px] text-gray-dark outline-none"
                    @input="handleDateFromInput"
                  />
                </div>
              </div>

              <div class="flex items-center justify-center self-center justify-self-center">
                <span class="text-[18px] leading-none text-extra-text-color">-</span>
              </div>

              <div class="flex flex-col gap-1">
                <span class="text-[16px] font-helvetica-400 text-gray-dark">по</span>
                <div class="flex min-w-0 items-center gap-1.5 rounded-[12px] border border-gray-border bg-white px-[10px] py-[12px]">
                  <SvgoIconComponentRIconCalendar class="text-orange"></SvgoIconComponentRIconCalendar>
                  <input
                    :value="searchDateTo"
                    type="date"
                    class="min-w-0 w-full bg-transparent p-0 font-helvetica-400 text-[14px] text-gray-dark outline-none"
                    @input="handleDateToInput"
                  />
                </div>
              </div>
            </div>

            <div class="mt-4 flex flex-col gap-3">
              <button
                type="button"
                class="flex h-[52px] items-center justify-center rounded-[14px] border border-gray-border px-4 text-[17px] text-gray-dark"
                @click="clearDateFilter"
              >
                Сбросить
              </button>
              <button
                type="button"
                class="flex h-[52px] items-center justify-center rounded-[14px] border border-orange bg-orange px-4 text-[17px] text-white"
                @click="applyDateFilter"
              >
                Применить
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      v-if="showDatePopover"
      class="shadow-popover-soft absolute left-4 right-4 top-[76px] z-20 hidden rounded-[12px] border border-gray-border bg-white p-[12px] lg:left-auto lg:right-[15px] lg:block lg:w-[290px]"
    >
      <div class="flex items-center gap-2.5">
        <div
          class="flex min-w-0 flex-1 items-center gap-1.5 rounded-[10px] border border-gray-border bg-white px-[10px] py-[8px]"
        >
          <SvgoIconComponentRIconCalendar class="text-orange"></SvgoIconComponentRIconCalendar>
          <input
            :value="searchDateFrom"
            type="date"
            class="min-w-0 w-full bg-transparent p-0 font-helvetica-400 text-[14px] text-gray-dark outline-none"
            @input="handleDateFromInput"
          />
        </div>

        <div
          class="flex min-w-0 flex-1 items-center gap-1.5 rounded-[10px] border border-gray-border bg-white px-[10px] py-[8px]"
        >
          <SvgoIconComponentRIconCalendar class="text-orange"></SvgoIconComponentRIconCalendar>
          <input
            :value="searchDateTo"
            type="date"
            class="min-w-0 w-full bg-transparent p-0 font-helvetica-400 text-[14px] text-gray-dark outline-none"
            @input="handleDateToInput"
          />
        </div>
      </div>

      <div class="mt-2.5 flex items-center justify-end gap-2">
        <button
          type="button"
          class="rounded-[8px] border border-gray-border px-2.5 py-1.5 text-[12px] text-gray-light hover:text-gray-dark cursor-pointer"
          @click="clearDateFilter"
        >
          Сбросить
        </button>
        <button
          type="button"
          class="rounded-[8px] border border-orange px-2.5 py-1.5 text-[12px] text-orange hover:bg-orange hover:text-white cursor-pointer"
          @click="applyDateFilter"
        >
          Применить
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    managerName?: string;
    managerOnline?: boolean;
    searchOpen?: boolean;
    searchText?: string;
    searchDateFrom?: string;
    searchDateTo?: string;
    searchLoading?: boolean;
    searchError?: string;
  }>(),
  {
    managerName: "",
    managerOnline: false,
    searchOpen: false,
    searchText: "",
    searchDateFrom: "",
    searchDateTo: "",
    searchLoading: false,
    searchError: "",
  },
);

const emit = defineEmits<{
  (e: "openSearch"): void;
  (e: "closeSearch"): void;
  (e: "update:searchText", value: string): void;
  (e: "update:searchDateFrom", value: string): void;
  (e: "update:searchDateTo", value: string): void;
  (e: "search"): void;
}>();

const showDatePopover = ref(false);
const searchInputRef = ref<HTMLInputElement | null>(null);

const managerName = computed(() => String(props.managerName ?? "").trim());
const managerOnline = computed(() => Boolean(props.managerOnline));
const searchOpen = computed(() => Boolean(props.searchOpen));
const searchDateFrom = computed(() => String(props.searchDateFrom ?? ""));
const searchDateTo = computed(() => String(props.searchDateTo ?? ""));

const searchValue = computed({
  get: () => String(props.searchText ?? ""),
  set: (value: string) => emit("update:searchText", value),
});

const managerInitial = computed(() => {
  const letter = managerName.value.charAt(0).toUpperCase();
  return letter || "";
});

const clearDateFilter = () => {
  emit("update:searchDateFrom", "");
  emit("update:searchDateTo", "");
  emit("search");
};

const applyDateFilter = () => {
  emit("search");
  showDatePopover.value = false;
};

const handleCloseSearch = () => {
  showDatePopover.value = false;
  emit("closeSearch");
};

const handleDateFromInput = (event: Event) => {
  const target = event.target as HTMLInputElement | null;
  emit("update:searchDateFrom", target?.value ?? "");
};

const handleDateToInput = (event: Event) => {
  const target = event.target as HTMLInputElement | null;
  emit("update:searchDateTo", target?.value ?? "");
};

watch(
  () => searchOpen.value,
  (opened) => {
    if (!opened) {
      showDatePopover.value = false;
      return;
    }

    nextTick(() => {
      searchInputRef.value?.focus();
    });
  },
);
</script>
